<template>
    <div class="card student">
        <div class="card-content">
            <div class="media">
                <div class="media-left">
                    <router-link :to="{ name: 'students.profile', params: { slug: student.slug }}">
                        <avatar :account="student" :size="92" />
                    </router-link>
                </div>

                <div class="media-content">
                    <router-link :to="{ name: 'students.profile', params: { slug: student.slug }}">
                        <h3 class="title name is-spaced is-size-5">{{student.name}}</h3>
                    </router-link>

                    <div class="student-level">
                        <span class="has-text-weight-bold">{{$t('students.profile.level')}}:</span>

                        <small>
                            {{$t(`levels.${level.name}.name`)}} <level-icon :level="level" size="is-small" />
                        </small>
                    </div>


                    <div>
                        <stars v-if="student.average_rating" :average="student.average_rating" size="is-small" />
                    </div>
                </div>
            </div>

            <div class="skills">
                <p class="skills__header has-text-weight-bold">
                    Færdigheder:
                </p>

                <b-field grouped group-multiline>
                    <skill-tag v-for="skill in prioritizedSkills" :key="skill.id" :skill="skill" :pay-grade="paygrade(skill)" />
                </b-field>
            </div>
        </div>

        <footer class="card-footer">
            <div class="card-footer-item">
                <div class="buttons">
                    <router-link class="button is-outlined" :to="{ name: 'students.profile', params: { slug: student.slug }}">
                        <b-icon icon="eye" />
                        <span>Profil</span>
                    </router-link>

                    <span class="button is-primary" v-if="isCustomer || !isLoggedIn" @click="toggleContactModal">
                        <b-icon icon="message-text" />
                        <span>{{$t('global.actions.contact')}}</span>
                    </span>

                    <contact-modal v-if="showContactModal" @hide="toggleContactModal" :student="student" />
                </div>
            </div>
        </footer>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/_variables';

    .student {
        display: flex;
        flex-direction: column;
        height: 100%;

        .card-content {
            padding: 1rem;
            text-align: left;


            .name {
                margin-bottom: 0.5rem;
            }

            .student-level {
                margin-bottom: 0.25rem;
            }

            .skills .skills__header {
                margin-bottom: 0.5rem;
            }
        }

        .card-footer {
            margin-top: auto;
        }
    }
</style>

<script>
    import { mapGetters } from 'vuex';
    import Avatar from '@/taskflex/users/components/Avatar';
    import ContactModal from '@/taskflex/students/components/contact/ContactModal';
    import LevelIcon from '@/taskflex/levels/components/LevelIcon';
    import Stars from '@/taskflex/students/components/profile/ratings/Stars';
    import SkillTag from '@/taskflex/skills/components/SkillTag';

    export default {
        data() {
            return {
                showContactModal: false,
            };
        },

        props: {
            student: {
                type: Object,
            },

            displaySkill: {
                type: Object,
            },

            columnWidth: {
                type: Number,
                default: 4,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isCustomer',
                'isLoggedIn',
            ]),

            prioritizedSkills() {
                const { skills } = this.student;
                const { displaySkill } = this;

                if (!displaySkill) {
                    return skills;
                }

                return skills.sort((a) => {
                    if (a.id === displaySkill.id) {
                        return -1;
                    }

                    return 1;
                });
            },

            level() {
                const { level } = this.student;

                return level;
            },

            skills() {
                const { skills } = this.student;

                return skills;
            },
        },

        methods: {
            paygrade(skill) {
                const { level } = this;
                const { paygrades } = skill;

                return paygrades.find(paygrade => paygrade.level_id === level.id);
            },

            toggleContactModal() {
                this.showContactModal = !this.showContactModal;
            },
        },

        components: {
            Avatar,
            ContactModal,
            LevelIcon,
            SkillTag,
            Stars,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/search/Student.vue